import { useSelector } from 'react-redux';
import { FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { parsePriceFormat } from 'Containers/Result/components/PaymentLater/utils';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { FRONT_PLANS } from 'Constants/plans';
import { ResultTypes } from 'Types/common';
import * as Styled from './styles';

const NOT_MANDATORY_CONTEXT = 'notMandatory';

const PRICE = 299;
const FlexLiteInfo = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const paymentLaterProps = useSelector(routeStateSelector);

  const isNotMandatory =
    !paymentLaterProps?.mandatory &&
    (paymentLaterProps?.taxReturnType === ResultTypes.toPay ||
      paymentLaterProps?.taxReturnType === ResultTypes.equal);

  const tContext = isNotMandatory && NOT_MANDATORY_CONTEXT;
  return (
    <Styled.InfoContainer direction="column" align="center" gap="dimension_16">
      <FlexContainer align="center" gap="dimension_04">
        <img src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/live_logo.svg`} alt="live_logo" />
        <Text type="headline" size="S_L_M" color="dark">
          {FRONT_PLANS.FLEX}
        </Text>
      </FlexContainer>
      <Text type="paragraphs" size="M_XL_S" color="dark" align="center">
        {t(`Flex.lite.description`)}
      </Text>
      <FlexContainer direction="column" gap="dimension_08" fullWidth>
        <Styled.BulletContainer gap="dimension_08" fullWidth>
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`Plan.lite.Bullet.1`, { context: tContext })}
          </Text>
        </Styled.BulletContainer>
        <Styled.BulletContainer gap="dimension_08" fullWidth>
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`Plan.lite.Bullet.2`, { context: tContext })}
          </Text>
        </Styled.BulletContainer>
        <Styled.BulletContainer gap="dimension_08" fullWidth justify="space-between">
          <Icon icon="TickXS" color="active" />
          <Text type="paragraphs" color="grey" size="S_M_S">
            {t(`Plan.lite.Bullet.3`, { context: tContext })}
          </Text>
        </Styled.BulletContainer>
      </FlexContainer>
      <Styled.PriceContainer direction="column" fullWidth>
        <FlexContainer justify="space-between" align="center">
          <Text type="paragraphs" size="S_L_S" color="dark" align="center">
            {t(`PayLater.plan`)}
          </Text>
          <FlexContainer gap="dimension_10">
            <Styled.Price type="paragraphs" size="M_S_S" color="danger_strong" align="center">
              {YayoyakiFormatter.formatAmountMxn(PRICE)}
            </Styled.Price>
            <Text type="paragraphs" size="M_XL_S" color="dark" align="center">
              {parsePriceFormat(0)}
            </Text>
          </FlexContainer>
        </FlexContainer>
      </Styled.PriceContainer>
    </Styled.InfoContainer>
  );
};

export default FlexLiteInfo;
